import { FEATURES, useFeatureToggles } from '@belong/feature-toggles';
import { BUTTON_VARIANTS } from '@belong/themes';
import { IButton } from '@belong/types';
import { useFormLoading } from '../FormLoadingProvider';

export const useFormButtonState = ({ variant, iconOnly }: Pick<IButton, 'variant' | 'iconOnly'>) => {
  const { isLoading, useButtonSpinner } = useFormLoading();
  const buttonLoadingToggle = useFeatureToggles().isFeatureOn(FEATURES.ACCESSIBLE_FORM_LOADING);
  const isPrimary = variant === BUTTON_VARIANTS.PRIMARY;
  const canUseInlineSpinner = buttonLoadingToggle && useButtonSpinner && isPrimary && !iconOnly;
  const isInlineSpinnerLoading = canUseInlineSpinner && isLoading;
  return { isLoading, isInlineSpinnerLoading };
};
